/* Core & libraries */
import React, { useEffect, useState } from 'react';
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useReportsService} from "../../../../../services/reportsService";

/* Components */
import SelectBookingDates from "../../../../selectBookingDates";
import UCButton from "../../../../buttons";
import { ReactComponent as DownloadIcon } from "../../../../../resources/images/download-02.svg";

/* Styles */
import styles from "./styles.js"
import UCSelect from '../../../../ucselect';
import { customSelectStyles } from '../../bookingsTab/bookingFilters/styles';

const messages = defineMessages({
  yearToDateLabel: {
    id: 'bookings.filters.yearToDate',
  },
  travelDateLabel: {
    id: 'bookings.filters.allTime',
  },
  downloadTravelCSV: {
    id: 'receipts.button',
  },
});

const CouponsFilters = ({gridOptions, setGridOptions, enableDownloadButton}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const intl = useIntl();

  const { downloadCouponsReport, getTicketStatusOptions } = useReportsService();
  const [showBookingOverlay, setShowBookingOverlay] = useState(false);
  const [showTravelOverlay, setShowTrevelsOverlay] = useState(false);
  const [ticketStatusOptions, setTicketStatusOptions] = useState([]);

  const handleDownload = () => {
    downloadCouponsReport(gridOptions)
  }
  useEffect(() => {
    const fetchTicketStatus = async () => {
      const optionTicketStatus = await getTicketStatusOptions('O_TICKETSTATUS');
      if (
        optionTicketStatus?.options[0]?.options &&
        optionTicketStatus?.options[0]?.options.length > 0
      ) {
        const allStatusOption = {
          value: '',
          label: <FormattedMessage id="reports.status.all" />,
        };
        const ticketStatusOptions = optionTicketStatus?.options[0]?.options.map((s) => ({
          value: s.optionValue,
          label: s.optionText,
        }));
        setTicketStatusOptions([allStatusOption, ...ticketStatusOptions]);
      }
    };
    fetchTicketStatus();
  }, []);
  return (
    <div className={classes.filters}>
      <div className={classes.filterButtons}>
        <div className={classes.filterText}>
          <p>
            <FormattedMessage id="reports.status.label" />
          </p>
          <UCSelect
            className={classes.airlines}
            styles={customSelectStyles}
            displayName={<FormattedMessage id="reports.status.all" />}
            options={ticketStatusOptions}
            defaultValue={{
              value: '',
              label: <FormattedMessage id="reports.status.all" />,
            }}
            onChange={(item) =>
              setGridOptions({
                ...gridOptions,
                page: 1,
                filters: {
                  TICKETSTATUS: [item.value],
                },
              })
            }
          />
        </div>
        <div className={classes.filterDates}>
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="bookings.filters.bookingDate" />
            </p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.yearToDateLabel)}
              defaultValue="yearToDate"
              id={'booking'}
              showOverlay={showBookingOverlay}
              setShowOverlay={setShowBookingOverlay}
            />
          </div>
          <div className={classes.filterText}>
            <p>
              <FormattedMessage id="bookings.filters.travelDate" />
            </p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.travelDateLabel)}
              defaultValue="allTime"
              id={'travel'}
              showOverlay={showTravelOverlay}
              setShowOverlay={setShowTrevelsOverlay}
            />
          </div>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <UCButton
          type="primary"
          className={classes.button}
          onClick={handleDownload}
          text={<FormattedMessage id="receipts.button" />}
          icon={<DownloadIcon />}
          disabled={!enableDownloadButton}
          loadingStateStyling={classes.downloadCsvLoadingState}
          ariaLabel={intl.formatMessage(messages.downloadTravelCSV)}
          tabIndex={0}
          spinner={{
            name: 'downloadBookingsSpinner',
            size: 20,
          }}
        />
      </div>
    </div>
  );
}

export default CouponsFilters;
